import app from './feathers'
import { chatStore } from '../stores/chatStore'
const chatConfigService = app.service('chat-config')

const methods = {
    async get() {
        const chatConfigs = await chatConfigService.find()
        chatStore.set(chatConfigs.data)
        return chatStore
    },

    async create(chatConfig) {
        const res = await chatConfigService.create(chatConfig)
        chatStore.add(res)
        return res
    },

    async update(id, config) {
        const res = await chatConfigService.update(id, config)
        chatStore.update(res)
        return res
    },

    async remove(chatConfigId) {
        const res = await chatConfigService.remove(chatConfigId)
        chatStore.remove(res._id)
        return res
    },
}

export default methods
